import React from 'react'
import { Redirect } from 'react-router-dom'
import { connect } from 'react-redux'
import withApp from '@brainstud/react-tbl/core/provider/withApp'
// TODO move ui
// import { Page, PageContent, Card, SourceLink } from '@brainstud/schiphol-vtc-ui'
// TODO get appRoutes from provider
import { appRoutes } from '@brainstud/react-tbl/features'
import { routeTo, getBySlug } from '@brainstud/react-helpers'
import { NavigationView } from '@brainstud/react-tbl/features/navigation'
import IntroType from './intro'
import { DevMode } from '../shared'

class ChapterView extends React.Component {
  componentDidMount() {
    // console.log('chapter mount', this.props.match.params)
  }

  componentDidUpdate(props) {
    // console.log('chapter update', this.props.match.params)
  }

  render() {
    if(!this.props.chapter)
      return <Redirect to={routeTo(appRoutes, 'home')} />

    return (
      <NavigationView type="chapter" id={this.props.chapter.id}>
        <Page background={this.props.chapter.background}>
          <PageContent>
            <Card {...this.props.card}>
              <IntroType type={this.props.chapter.type} {...this.props} />
            </Card>
          </PageContent>

          {this.props.chapter.backgroundSource &&
            <SourceLink
              style={{ top: '25%' }}
              to={this.props.chapter.backgroundSource} />
          }

          {process.env.NODE_ENV === 'development' &&
            <DevMode chapter={this.props.chapter} lesson={this.props.lesson} />
          }
        </Page>
      </NavigationView>
    )
  }
}

export default withApp(connect(
  (state, props) => {
    const chapters = state.chapters.chapters.byId
    const lessons = state.chapters.lessons.byId

    const chapter = getBySlug(chapters, props.match.params.chapter)
    if(!chapter) return { chapter: false }

    const nextLesson = lessons[chapter.lessons[0]]

    const hasCurrentLesson = state.chapters.progress[chapter.slug]
    const currentLesson = hasCurrentLesson
      ? { chapter: chapter.slug, lesson: hasCurrentLesson }
      : nextLesson
        ? { chapter: chapter.slug, lesson: nextLesson.slug }
        : false

    const card = {
      number: chapter.prefix,
      title: chapter.title,
      theme: props.app.themes[props.app.currentTheme],
      backButtonTo: routeTo(appRoutes, 'home'),
      nextButtonLabel: hasCurrentLesson ? 'Ga verder' : 'Start',
      nextButtonTo: currentLesson && routeTo(appRoutes, 'lesson', currentLesson),
    }

    return { chapter, card }
  },
  () => ({}),
)(ChapterView))
